<template>
  <div class="emme body">
    <div
      class="tp-viewport"
      ref="captionsContainer"
      aria-label="Traduzione in tempo reale (ultime tre righe)"
    >
      <div
        v-for="cap in captions"
        :key="cap.offset"
        class="tp-line"
      >
        {{ cap.text }}
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import * as signalR from '@aspnet/signalr'
import constants from '../lib/constants'

export default {
  name: 'Emme',
  props: {
    // come nelle altre view, arriva dal router (<router-view :client-id="clientId" />)
    clientId: { type: String, required: true }
  },
  data () {
    return {
      // SOLO le ultime 3 righe
      captions: [],
      connection: null,

      // sessione e lingua fisse come richiesto
      sessionName: 'camera',
      toLanguageCode: 'it', // usa 'it-IT' se il backend richiede BCP-47 completo

      // layout
      lineHeight: 48,  // deve combaciare con CSS (--lh)
      maxKeepLines: 3
    }
  },
  methods: {
    async updateLanguageSubscription () {
      // lascia eventuale stanza precedente (best-effort)
      try {
        await axios.post(`${constants.apiBaseUrl}/api/leave`, { userId: this.clientId })
      } catch (_) {}

      // iscrizione alla lingua IT per la sessione desiderata
      await axios.post(`${constants.apiBaseUrl}/api/selectlanguage`, {
        languageCode: this.toLanguageCode,
        userId: this.clientId,
        sessionName: this.sessionName
      })
    },
    _smoothScrollToBottom () {
      const el = this.$refs.captionsContainer
      if (!el) return
      // tiene il focus visivo sul fondo (dove arriva l'ultima riga)
      el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' })
    },
    _trimToMax (map) {
      // mantiene solo le ultime N righe
      while (this.captions.length > this.maxKeepLines) {
        const removed = this.captions.shift()
        if (removed) delete map[removed.offset]
      }
    }
  },
  async mounted () {
    // Consenti override della sessione via query (?name=xxx)
    if (this.$route && this.$route.query && this.$route.query.name) {
      this.sessionName = String(this.$route.query.name)
    }

    // Connessione SignalR
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${constants.apiBaseUrl}/api/${this.clientId}`)
      .build()

    const captionsMap = {}

    this.connection.on('newCaption', (caption) => {
      // compattiamo per offset: aggiorna se già presente, altrimenti crea
      let local = captionsMap[caption.offset]
      if (!local) {
        local = { offset: caption.offset, text: caption.text }
        this.captions.push(local)
        captionsMap[caption.offset] = local
      } else {
        local.text = caption.text
      }

      this.$nextTick(() => {
        this._trimToMax(captionsMap)  // garantisce solo ultime 3 righe
        this._smoothScrollToBottom()  // mantiene la vista sul fondo
      })
    })

    await this.connection.start()
    await this.updateLanguageSubscription()
  },
  async beforeDestroy () {
    if (this.connection) {
      try { await this.connection.stop() } catch (_) {}
    }
  }
}
</script>

<style scoped>
/* Variabili locali */
.emme.body {
  --lh: 48px;             /* deve combaciare con data().lineHeight */
  --font-size: 32px;
  min-height: 100vh;
  background: #000;       /* sfondo nero */
  color: #fff;            /* testo bianco */
  display: grid;
  place-items: center;    /* centra il "riquadro" di 3 righe nella pagina */
  padding: 0;
  margin: 0;
}

/* Contenitore che mostra SOLO tre righe */
.tp-viewport {
  width: min(1200px, 92vw);
  height: calc(var(--lh) * 3);  /* mostra solo 3 righe */
  overflow: hidden;             /* niente scrollbars visibili */
  padding: 8px 24px;
  box-sizing: border-box;

  /* resa e performance */
  -webkit-font-smoothing: antialiased;
  backface-visibility: hidden;
  transform: translateZ(0);
}

/* Singola riga */
.tp-line {
  margin: 0;
  line-height: var(--lh);
  font-size: var(--font-size);
  color: #fff;
  text-align: left;       /* allineato a sinistra come richiesto */
  white-space: normal;
  word-break: break-word;
}

/* Mobile */
@media (max-width: 768px) {
  .emme.body { --lh: 44px; --font-size: 28px; }
}
</style>
